import { Flame, Instagram, Twitter, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#4A148C] text-[#FFF9F2] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Flame className="w-6 h-6 text-[#FFB300] diya-flame" />
            <div className="font-display text-2xl">Mona&apos;s Creations</div>
          </div>
          <p className="font-body text-sm text-[#FFCF52]/90 leading-relaxed">
            Handcrafted treasures from the artisans of India — every piece tells a story of tradition, warmth, and celebration.
          </p>
        </div>
        <div>
          <div className="font-display text-lg mb-4">Shop</div>
          <ul className="space-y-2 text-sm font-body text-[#FFCF52]/85">
            <li>Diyas & Lamps</li>
            <li>Brass & Metalware</li>
            <li>Textiles</li>
            <li>Rangoli & Décor</li>
          </ul>
        </div>
        <div>
          <div className="font-display text-lg mb-4">Support</div>
          <ul className="space-y-2 text-sm font-body text-[#FFCF52]/85">
            <li>Shipping & Returns</li>
            <li>Order Tracking</li>
            <li>Contact Us</li>
            <li>FAQs</li>
          </ul>
        </div>
        <div>
          <div className="font-display text-lg mb-4">Stay in touch</div>
          <p className="text-sm font-body text-[#FFCF52]/85 mb-4">
            Festive updates, artisan stories, and early access to sales.
          </p>
          <div className="flex gap-3">
            <a href="#" className="w-9 h-9 rounded-full bg-[#6A2AB0] hover:bg-[#E65C00] flex items-center justify-center transition-colors" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-[#6A2AB0] hover:bg-[#E65C00] flex items-center justify-center transition-colors" aria-label="Twitter">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-[#6A2AB0] hover:bg-[#E65C00] flex items-center justify-center transition-colors" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#6A2AB0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs font-body text-[#FFCF52]/70">
          <div>© {new Date().getFullYear()} Mona&apos;s Creations · Made with warmth in India</div>
          <div>Diwali · Holi · Raksha Bandhan · Every day is festive here</div>
        </div>
      </div>
    </footer>
  );
}
